import { render, staticRenderFns } from "./HistoryRetur.vue?vue&type=template&id=24915c4c&scoped=true&"
import script from "./HistoryRetur.vue?vue&type=script&lang=js&"
export * from "./HistoryRetur.vue?vue&type=script&lang=js&"
import style0 from "./Ekspedisi.scss?vue&type=style&index=0&id=24915c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24915c4c",
  null
  
)

export default component.exports